import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { hotRanking, films } from "@/mocks/films";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  same: "ri-subtract-line",
};

const trendColor: Record<string, string> = {
  up: "text-primary-600",
  down: "text-secondary-600",
  same: "text-foreground-400",
};

export default function HotRanking() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-primary-950">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-accent-500" />
              <span className="font-label text-xs tracking-[0.28em] uppercase text-accent-500">
                Ranking
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              热播榜 TOP 10：这几天大家在看什么
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-300">
              榜单综合近期播放与收藏热度排序，每天更新。名次浮动会同步反映在下方趋势标记中，帮你判断哪些片子正在被讨论。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 md:gap-x-12 mt-10 md:mt-12">
          {hotRanking.map((item, i) => {
            const film = films.find((f) => f.id === item.filmId);
            if (!film) return null;
            return (
              <Reveal key={item.rank} delay={i * 40}>
                <div className="flex items-center gap-4 md:gap-5 py-4 border-b border-background-800/70">
                  <span
                    className={`font-heading text-2xl md:text-3xl font-bold w-9 md:w-11 shrink-0 ${
                      item.rank <= 3 ? "text-accent-500" : "text-background-600"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading text-base md:text-lg font-semibold text-background-50">
                        {film.title}
                      </h3>
                      <span className="font-label text-[11px] px-2 py-0.5 rounded-md bg-background-800/60 text-background-300">
                        {film.category}
                      </span>
                      <i
                        className={`${trendIcon[item.trend]} ${trendColor[item.trend]} text-sm`}
                        aria-hidden="true"
                      />
                    </div>
                    <p className="text-xs md:text-sm text-background-400 mt-1.5 line-clamp-1">
                      {film.summary}
                    </p>
                  </div>
                  <div className="shrink-0 text-right w-20 md:w-24">
                    <p className="font-heading text-lg font-bold text-accent-500">
                      {film.score.toFixed(1)}
                    </p>
                    <div className="h-1 rounded-full bg-background-800 mt-1.5 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-accent-500/80"
                        style={{ width: `${item.heat}%` }}
                      />
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}